import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomPanel,
  OutlinedBtnPrimary,
  PageHeader,
  SectionTitle,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import ModalNovaPrestacaoContas from './ModalNovaPrestacaoContas'
import { errorHandler } from '../../../../services/util/error.service'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import ModalCanhoto from './ModalCanhoto'
import ModalApuracaoFisica from './ModalApuracaoFisica'
import ModalResumoPrestacaoContas from '../MovimentacaoLastMile/ModalResumoPrestacaoContas/ModalResumoPrestacaoContas'

function PrestacaoContaLastMile({ dispatch, history }) {
  const {
    id: movimentacao_last_mile_id,
    data_movimentacao,
    transportadora_name,
    placa,
    ativos,
  } = history.location.state.item

  const [prestacoes, setPrestacoes] = useState([])
  const [selectedPrestacaoContas, setSelectedPrestacaoContas] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [showModalCanhoto, setShowModalCanhoto] = useState(null)
  const [showModalApuracaoFisica, setShowModalApuracaoFisica] = useState(null)
  const [modalResumoPrestacao, setModalResumoPrestacao] = useState({ show: false, data: true })

  useEffect(() => {
    if (movimentacao_last_mile_id) {
      setIsLoading(true)
      MovimentacaoLastMileHttp.getPrestacoesContas(movimentacao_last_mile_id)
        .then(prestacoesContas => {
          setIsLoading(false)
          setPrestacoes(prestacoesContas)
        })
        .catch(error => {
          setIsLoading(false)
          dispatch(showMessageBox(null, error))
        })
    }
  }, [movimentacao_last_mile_id])

  //Events
  const onNovoClick = () => {
    setSelectedPrestacaoContas({
      id: null,
      movimentacao_last_mile_id,
    })
  }
  const onMenuItemClick = (menuItem, item) => {
    switch (menuItem) {
      case 'Canhotos':
        setShowModalCanhoto(item)
        break
      case 'Apagar':
        apagarPrestacao(item.id)
        break
      case 'Apuração Física':
        setShowModalApuracaoFisica(item)
        break
      case 'Emitir Comprovante':
        MovimentacaoLastMileHttp.emitirComprovantePrestacaoConta(item.id)
        break
      default:
        break
    }
  }
  const onModalResponse = (action, payload) => {
    if (action === 'close') {
      setSelectedPrestacaoContas(null)
      setShowModalApuracaoFisica(null)
      setModalResumoPrestacao({ show: false, data: null })
    } else if (action === 'error') {
      dispatch(showMessageBox(null, errorHandler(payload)))
    } else if (action === 'success') {
      setSelectedPrestacaoContas(null)
      setShowModalApuracaoFisica(null)

      setPrestacoes(prevState => {
        const index = prevState.findIndex(p => p.id === payload.id)
        if (index !== -1) {
          prevState[index] = payload
        } else {
          prevState.push(payload)
        }
        return [...prevState]
      })
    }
  }

  const onModalCanhotoResponse = (action, payload) => {
    if (action === 'close') {
      setShowModalCanhoto(null)
    } else if (action === 'error') {
      dispatch(showMessageBox(null, errorHandler(payload)))
    } else if (action === 'success') {
      setPrestacoes(prevState => {
        const index = prevState.findIndex(p => p.id === payload.prestacao_contas_id)
        if (index !== -1) {
          prevState[index].canhotos = payload.canhotos
        }
        return [...prevState]
      })
    }
  }

  // Helper
  const apagarPrestacao = prestacaoId => {
    setIsLoading(true)
    MovimentacaoLastMileHttp.apagarPrestacaoContas(prestacaoId)
      .then(() => {
        setPrestacoes(prevState => {
          return prevState.filter(p => p.id !== prestacaoId)
        })
        dispatch(showMessageBox('Operação realizada com Sucesso', null))
      })
      .catch(error => {
        dispatch(showMessageBox(null, errorHandler(error)))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  // Render
  return (
    <>
      <PageHeader>6.5 - Prestação de Contas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onNovoClick} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <SectionTitle title={'Movimentação Last Mile'} />
            </div>
            <div className="p-col-2">
              Controle: &nbsp;<strong>{movimentacao_last_mile_id}</strong>
            </div>
            <div className="p-col-3">
              Data Movimentação: &nbsp;<strong>{data_movimentacao}</strong>
            </div>
            <div className="p-col-2">
              Placa: &nbsp;<strong>{placa}</strong>
            </div>
            <div className="p-col-5">
              Transportadora: &nbsp;<strong>{transportadora_name}</strong>
            </div>
            <div className="p-col-12" style={{ marginTop: 16 }}>
              <OutlinedBtnPrimary
                label={'Resumo Prestação Contas'}
                onClick={() => {
                  setModalResumoPrestacao({ show: true, data: history.location.state.item })
                }}
              />
            </div>
            <div className="p-col-12" style={{ marginTop: 16 }}>
              <DataTable
                value={prestacoes}
                emptyMessage={'Não existe Prestação Conta cadastrada '}
                rows={5}
                paginator={true}
                loading={isLoading}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered(80)} />
                <Column
                  field={'data_prestacao_contas'}
                  header={'Data'}
                  style={tableCellCentered(150)}
                />
                <Column field={'user_name'} header={'Responsável'} />
                <Column
                  header={'#'}
                  body={item => (
                    <ThreeDots
                      items={['Apagar', 'Apuração Física', 'Canhotos', 'Emitir Comprovante']}
                      onClick={menuItem => onMenuItemClick(menuItem, item)}
                    />
                  )}
                  style={tableCellCentered(80)}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalNovaPrestacaoContas
        selectedPrestacaoContas={selectedPrestacaoContas}
        visible={selectedPrestacaoContas !== null}
        onResponse={onModalResponse}
      />
      <ModalApuracaoFisica
        ativos={ativos}
        selectedPrestacaoContas={showModalApuracaoFisica}
        visible={showModalApuracaoFisica !== null}
        onResponse={onModalResponse}
      />
      <ModalCanhoto
        ativos={ativos}
        selectedPrestacaoContas={showModalCanhoto}
        visible={showModalCanhoto !== null}
        onResponse={onModalCanhotoResponse}
      />
      <ModalResumoPrestacaoContas
        modal={modalResumoPrestacao}
        onResponse={onModalResponse}
        prestacoes={prestacoes}
      />
    </>
  )
}

export default connect()(withRouter(PrestacaoContaLastMile))
